import React from 'react';
import { Box, Container } from '@mui/material';
import FnMenu from '../../../components/Menu';
import BackHomeButton from '../../../components/BackHomeButton';
import Documentation from '../Documentation/Index';
import Welcome from '../Welcome/Index';

export default function Menu() {
  return (
    <Container style={{ maxWidth: 'unset', padding: 0 }}>
      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#262626',
        }}
      >
        <BackHomeButton />
        <FnMenu
          listTab={[
            {
              label: 'Bem vindo',
              value: 'bemVindo',
              pageRedirect: <Welcome />,
            },
            {
              label: 'Documentação',
              value: 'documentacao',
              pageRedirect: <Documentation />,
            },
          ]}
          valueInitial="bemVindo"
        />
      </Box>
    </Container>
  );
}
